import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreModule } from '../core';
import { TransactionRoutingModule } from './transaction-routing.module';
import { TransactionsComponent } from './transactions';
import { TransactionAddComponent } from './transaction.add.component';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { OffersComponent } from './offers.component';
import { SalesComponent } from './sales.component';
import { AccountsComponent } from './accounts.component';

@NgModule({
  imports: [CommonModule, BrowserModule, FormsModule, ReactiveFormsModule, NgSelectModule,
    CoreModule, TransactionRoutingModule, HttpModule],
  declarations: [TransactionsComponent, TransactionAddComponent, OffersComponent, SalesComponent, AccountsComponent],
  providers: []
})
export class TrxnModule { }
